module.exports = __webpack_public_path__ + "static/media/passwordimg.bd21ae62.jpg";